export default "__VITE_ASSET__a3f76f84__"